export function isNull (str) {
  return str === null || str === undefined || str === ''
}



// WEBPACK FOOTER //
// ./src/utils/common.js